module.exports = __webpack_public_path__ + "static/media/09_tn.cadff94c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/09_tn.jpg
// module id = 498
// module chunks = 0